import { Wallet } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import type { PayoutAccount } from "@/features/projects/services/projects-api.service";
import { FloatPanel, StudioButton } from "@/features/studio/theme";

export function PayoutAccountCard({
	payoutAccount,
	isLoading,
}: {
	payoutAccount: PayoutAccount | null;
	isLoading: boolean;
}) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	if (payoutAccount || isLoading) return null;

	return (
		<FloatPanel elevation={1} padding={24}>
			<div className="space-y-2">
				<div className="flex items-center gap-2">
					<Wallet className="h-5 w-5 text-dashboard-accent-dark" />
					<h3
						className="text-base font-semibold text-dashboard-text"
						style={{ fontFamily: "var(--font-display)" }}
					>
						{t("project.payments.payoutAccount")}
					</h3>
				</div>
				<p className="text-sm text-dashboard-muted">
					{t("project.payments.payoutAccountDesc")}
				</p>
			</div>

			<p className="mt-4 text-sm text-dashboard-muted-dark">
				{t("project.payments.noPayoutAccountPrompt")}
			</p>

			<div className="mt-4">
				<StudioButton
					variant="primary"
					size="sm"
					onClick={() => navigate("/settings#payout")}
				>
					{t("project.payments.addPayoutAccount")}
				</StudioButton>
			</div>
		</FloatPanel>
	);
}
